
export function Footer() {
  return (
    <footer id="contato" className="bg-slate-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div className="text-center md:text-left">
            <div className="mx-auto md:mx-0 mb-5 inline-flex items-center justify-center rounded-3xl bg-gradient-to-br from-white/35 via-white/30 to-white/25 px-8 py-6 ring-1 ring-white/30 shadow-[0_18px_35px_rgba(0,0,0,0.25)]">
              <img 
                src="https://mnnotgqwwzenmjfkzzmy.supabase.co/storage/v1/object/public/logotipos/master_vazamentos_header.jpg"
                alt="Master Caça Vazamentos - Detecção de Vazamentos em São Paulo" 
                loading="lazy" 
                decoding="async" 
                className="w-40 md:w-52 h-auto object-contain drop-shadow-sm mix-blend-multiply"
              />
            </div>
            <p className="text-white/80 mb-4 max-w-md mx-auto md:mx-0">
              Especialistas em detecção e reparo de vazamentos em São Paulo e região. Laudo técnico aceito pela SABESP. Garantia de 1 ano.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-10 h-10 bg-white/10 hover:bg-orange-500 rounded-lg flex items-center justify-center transition-all duration-300"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-10 h-10 bg-white/10 hover:bg-orange-500 rounded-lg flex items-center justify-center transition-all duration-300"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>
          
          <div className="text-center md:text-left">
            <h4 className="text-lg font-semibold mb-4">Links Rápidos</h4>
            <ul className="space-y-2">
              <li><a href="#home" className="text-white/80 hover:text-orange-500 transition-colors">Home</a></li>
              <li><a href="#servicos" className="text-white/80 hover:text-orange-500 transition-colors">Serviços</a></li>
              <li><a href="#como-funciona" className="text-white/80 hover:text-orange-500 transition-colors">Como Funciona</a></li>
              <li><a href="#credibilidade" className="text-white/80 hover:text-orange-500 transition-colors">Sobre Nós</a></li>
              <li><a href="#orcamento" className="text-white/80 hover:text-orange-500 transition-colors">Orçamento</a></li>
            </ul>
          </div>
          
          <div className="text-center md:text-left">
            <h4 className="text-lg font-semibold mb-4">Contato</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-orange-500 mt-1"></i>
                <span className="text-white/80 text-sm">
                  Av. Diederichsen 918 – Sala 15<br />
                  Jabaquara – São Paulo – SP<br />
                  CEP 04310-000
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-whatsapp-line text-orange-500"></i>
                <a href="https://wa.me/5511948948561" className="text-white/80 hover:text-orange-500 transition-colors">
                  (11) 94894-8561
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-orange-500"></i>
                <a href="mailto:cacavazamentosmaster@gmail.com" className="text-white/80 hover:text-orange-500 transition-colors">
                  cacavazamentosmaster@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm text-center md:text-left">
              © 2025 Master Caça Vazamentos. Todos os direitos reservados.<br />
              CNPJ: 07.531.351/0001-78
            </p>
          <div className="flex flex-col md:items-end gap-2 text-sm text-center md:text-right">
            <a
              href="https://amorimdanilo.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/20 bg-white/5 px-4 py-2 text-white/70 transition-colors hover:border-orange-500 hover:bg-orange-500/20 hover:text-white"
            >
              <i className="ri-external-link-line text-sm"></i>
              <span>Desenvolvido por Danilo Amorim</span>
            </a>
            <span className="text-white/50 text-xs">Deus seja louvado.</span>
          </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
